import { Anchor, Button, Stack, Text, TextInput, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router";
import { getCloudMetadata, getCurrentUser } from "./getCurrentUser";
import { persistReturnPath, redirectToSignIn } from "./authGuards";

export function Login({ returnTo: returnToProp }: { returnTo?: string } = {}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const user = getCurrentUser();
  const metadata = getCloudMetadata();
  const returnTo =
    returnToProp ?? params.get("return") ?? "/";
  const normalizedReturn = returnTo.startsWith("/") ? returnTo : "/" + returnTo;

  React.useEffect(() => {
    if (user) {
      navigate(normalizedReturn, { replace: true });
    }
  }, [user, normalizedReturn, navigate]);

  const onGoogleSignIn = () => {
    persistReturnPath(normalizedReturn);
    redirectToSignIn();
  };

  if (user) {
    return (
      <Stack gap="md" maw={480}>
        <Title order={3}>{t("signin.alreadySignedIn")}</Title>
        <Text>{t("signin.signedInAs", { email: user.AccountEmail || user.Email })}</Text>
        <Button component={Link} to={normalizedReturn}>
          {t("signin.continue")}
        </Button>
        <Anchor href="/logout">{t("nav.logout")}</Anchor>
      </Stack>
    );
  }

  return (
    <Stack gap="md" maw={480}>
      <Title order={3}>{t("signin.title")}</Title>
      <Text>{t("signin.intro")}</Text>
      <Button onClick={onGoogleSignIn}>{t("signin.withGoogle")}</Button>
      <Text size="sm" c="dimmed">
        {t("signin.agreePrefix")}{" "}
        <Anchor component={Link} to="/privacy">
          {t("signin.privacyLink")}
        </Anchor>
      </Text>
      {metadata.SignInUrl ? null : (
        <TextInput label={t("signin.debugSignInUrl")} value="(missing)" readOnly />
      )}
    </Stack>
  );
}
